import React from 'react'
import { gql } from '@apollo/client'
import { useNavigate } from 'react-router-dom'

import { QuestionType } from '../enums'
import { usePaginatedQuery } from 'hooks'
import { Card, Page, PageHeader, DataTable, ButtonAdd } from 'components'

const QUESTIONS_LIST_QUERY = gql`
  query QuestionList($offset: Int, $max: Int, $filter: QuestionFilter) {
    questionList(offset: $offset, max: $max, filter: $filter) {
      totalCount
      results {
        id
        text
        type
        dimension {
          name
        }
      }
    }
  }
`

const COLUMNS = [
  {
    Header: 'ID',
    accessor: 'id'
  },
  {
    Header: 'Text',
    accessor: 'text'
  },
  {
    Header: 'Tipo',
    accessor: data => QuestionType.toString(data.type)
  },
  {
    Header: 'Dimensão',
    accessor: 'dimension.name'
  }
]

export const QuestionListPage = () => {
  const navigate = useNavigate()
  const { data, loading, pageSize, pageIndex, fetchPage, setPageSize } = usePaginatedQuery(
    QUESTIONS_LIST_QUERY
  )

  console.log(data?.questionList?.results?.map(d => d.id))

  const onRowClick = row => navigate(`${row.original.id}`)
  const pageCount = Math.ceil(data?.questionList?.totalCount / pageSize)

  return (
    <Page>
      <PageHeader heading='Gerir Questões' onBack={() => navigate('..')}>
        <ButtonAdd onClick={() => navigate('criar')} />
      </PageHeader>

      <Card p={3}>
        <DataTable
          columns={COLUMNS}
          loading={loading}
          data={data?.questionList.results}
          onRowClick={onRowClick}
          onPage={fetchPage}
          onPageSize={setPageSize}
          pageIndex={pageIndex}
          pageCount={pageCount}
        />
      </Card>
    </Page>
  )
}

export default QuestionListPage
